const appName = () => {
    return process.env.VUE_APP_TITLE ? process.env.VUE_APP_TITLE : 'Netfest'
}


export default {
    appName: appName()
}

